import { render, staticRenderFns } from "./parent-full-report.vue?vue&type=template&id=0cc54500&"
import script from "./parent-full-report.vue?vue&type=script&lang=js&"
export * from "./parent-full-report.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports